import { render, staticRenderFns } from "./SlideContent.vue?vue&type=template&id=2cd38e40&scoped=true&"
import script from "./SlideContent.vue?vue&type=script&lang=js&"
export * from "./SlideContent.vue?vue&type=script&lang=js&"
import style0 from "./SlideContent.vue?vue&type=style&index=0&id=2cd38e40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd38e40",
  null
  
)

export default component.exports